module.exports = __webpack_public_path__ + "img/live_avatar.433a5177.jpg";